import {
    RATING_HIDE_UPDATE_ROW_FORM
} from './actionTypes';

export function hideForm() {
    return {
        type: RATING_HIDE_UPDATE_ROW_FORM
    }
}